import { render, staticRenderFns } from "./FadeInUpGroup.vue?vue&type=template&id=d4016984"
import script from "./FadeInUpGroup.vue?vue&type=script&lang=js"
export * from "./FadeInUpGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports